const uzCyrl = {
  app: {
    name: 'W&M',
    fullName: 'W&M Vending',
    tagline: 'Савдо автоматлари бошқаруви',
  },
  common: {
    save: 'Сақлаш',
    cancel: 'Бекор қилиш',
    delete: 'Ўчириш',
    edit: 'Таҳрирлаш',
    back: 'Орқага',
    search: 'Қидириш',
    actions: 'Амаллар',
    total: 'Жами',
    all: 'Барчаси',
    refresh: 'Янгилаш',
    retry: 'Қайта уриниш',
    exportCsv: 'CSV экспорт',
    viewAll: 'Барчасини кўриш',
    open: 'Очиш',
    more: 'Яна',
    loading: 'Юкланмоқда…',
    currency: 'сўм',
    pcs: 'дона',
    days: 'кун',
    noValue: '—',
    optional: 'ихтиёрий',
  },
  nav: {
    sectionMain: 'Асосий',
    sectionManage: 'Бошқарув',
    dashboard: 'Асосий саҳифа',
    checkout: 'Касса',
    reports: 'Ҳисоботлар',
    createReport: 'Ҳисобот юбориш',
    users: 'Ходимлар',
    branches: 'Филиаллар',
    products: 'Склад',
    collapse: 'Ён панелни йиғиш',
    expand: 'Ён панелни ёйиш',
    openMenu: 'Менюни очиш',
    home: 'Бош саҳифа',
  },
  header: {
    breadcrumb: 'Саҳифа йўли',
    search: 'Қидириш…',
    searchShortcut: 'Ctrl K',
    notifications: 'Билдиришномалар',
    noNotifications: 'Янги билдиришномалар йўқ',
    allGood: 'Ҳаммаси жойида',
    lowStockItem: 'Омборда {{count}} дона қолди',
    outOfStockItem: 'Омборда қолмади',
    theme: 'Мавзу',
    language: 'Тил',
    profile: 'Профил',
    editProfile: 'Профилни таҳрирлаш',
    logout: 'Чиқиш',
    administrator: 'Администратор',
    employee: 'Ходим',
  },
  theme: {
    system: 'Тизим',
    light: 'Ёруғ',
    dark: 'Қоронғи',
    night: 'Тунги',
  },
  search: {
    placeholder: 'Саҳифа, маҳсулот, филиал ёки ходимни қидиринг…',
    pages: 'Саҳифалар',
    products: 'Маҳсулотлар',
    branches: 'Филиаллар',
    users: 'Ходимлар',
    empty: 'Ҳеч нарса топилмади',
    hintNavigate: 'танлаш',
    hintOpen: 'очиш',
    hintClose: 'ёпиш',
  },
  filters: {
    period: 'Давр',
    today: 'Бугун',
    yesterday: 'Кеча',
    last7: '7 кун',
    last30: '30 кун',
    thisMonth: 'Жорий ой',
    custom: 'Махсус давр',
    branch: 'Филиал',
    allBranches: 'Барча филиаллар',
    product: 'Маҳсулот',
    allProducts: 'Барча маҳсулотлар',
    productsSelected: '{{count}} та маҳсулот',
    startDate: 'Бошланиш санаси',
    endDate: 'Тугаш санаси',
    reset: 'Фильтрларни тозалаш',
  },
  dashboard: {
    title: 'Бошқарув панели',
    subtitle: 'Савдо, омбор ва филиаллар ҳолати бир қарашда',
    kpi: {
      revenue: 'Умумий тушум',
      today: 'Бугунги тушум',
      units: 'Сотилган маҳсулотлар',
      profit: 'Ялпи фойда',
      avgDaily: 'Кунлик ўртача тушум',
      stock: 'Омбордаги қолдиқ',
      lowStock: 'Кам қолган маҳсулотлар',
      branches: 'Савдо қилган филиаллар',
    },
    vsPrevious: 'олдинги даврга нисбатан',
    vsYesterday: 'кечага нисбатан',
    noComparison: 'Таққослаш учун маълумот йўқ',
    skuCount: '{{count}} турдаги маҳсулот',
    lowStockHint: '{{count}} дона ва ундан кам',
    branchesHint: 'жами {{count}} та филиалдан',
    margin: 'Маржа: {{value}}',
    daysWithSales: '{{count}} та савдо куни',
    productFilterNote: 'Маҳсулот фильтри қўлланмайди',
    allInStock: 'Барча маҳсулотлар етарли',
    openReports: 'Батафсил ҳисобот',
  },
  charts: {
    salesDynamics: 'Савдо динамикаси',
    salesDynamicsSub: 'Кунлар кесимида, олдинги давр билан таққослаш',
    current: 'Жорий давр',
    previous: 'Олдинги давр',
    revenue: 'Тушум',
    profit: 'Фойда',
    units: 'Сотилган дона',
    cost: 'Таннарх',
    revenueVsCost: 'Тушум ва таннарх',
    revenueVsCostSub: 'Тушум = таннарх + ялпи фойда',
    byBranch: 'Филиаллар бўйича тушум',
    byBranchSub: 'Танланган даврда филиаллар улуши',
    topProducts: 'Топ 5 маҳсулот',
    topProductsSub: 'Сотилган дона бўйича',
    productShare: 'Маҳсулотлар улуши',
    productShareSub: 'Сотилган дона бўйича тақсимот',
    others: 'Бошқалар',
    share: 'Улуш',
    totalUnits: 'жами дона',
    dailyProfit: 'Кунлик фойда ўзгариши',
    productProfit: 'Маҳсулотлар бўйича фойда',
    singleBranch: 'Филиалларни таққослаш учун «Барча филиаллар»ни танланг',
  },
  tables: {
    recentDays: 'Сўнгги савдо кунлари',
    recentDaysSub: 'Кунлик тушум, сотув ва фойда',
    date: 'Сана',
    lowStock: 'Кам қолган маҳсулотлар',
    lowStockSub: 'Омборда {{count}} дона ва ундан кам қолганлар',
    remaining: 'Қолдиқ',
    rowsTotal: '{{from}}–{{to}}, жами {{total}}',
  },
  states: {
    emptyTitle: 'Маълумот топилмади',
    emptyPeriod: 'Танланган даврда савдо қайд этилмаган',
    emptyHint: 'Бошқа давр ёки филиални танлаб кўринг',
    emptySearch: 'Қидирув бўйича натижа йўқ',
    emptySearchHint: 'Сўровни ўзгартириб кўринг',
    errorTitle: 'Маълумотни юклаб бўлмади',
    errorHint: 'Сервер билан боғланишда хатолик юз берди. Қайта уриниб кўринг.',
  },
  checkout: {
    title: 'Касса',
    subtitle: '{{branch}} бўйича кунлик тушум',
    total: 'Давр бўйича жами',
    avgDay: 'Кунлик ўртача',
    bestDay: 'Энг юқори кун',
    days: 'Савдо кунлари',
    daily: 'Кунлик тушум',
    dailySub: 'Ҳар бир кун учун кассадаги тушум',
  },
  reports: {
    title: 'Ҳисоботлар',
    titleFor: '{{branch}} ҳисоботи',
    subtitle: 'Маҳсулотлар ва кунлар кесимида сотув',
    productName: 'Маҳсулот номи',
    quantity: 'Сони',
    profit: 'Фойдаси',
    overall: 'Умумий',
    total: 'Жами',
    exportName: 'hisobot',
  },
  createReport: {
    title: 'Ҳисобот юбориш',
    subtitle: 'Филиал бўйича кунлик сотилган маҳсулотларни киритинг',
    branch: 'Филиал',
    branchPlaceholder: 'Филиални танланг',
    date: 'Сана',
    searchProduct: 'Маҳсулот қидириш',
    searchPlaceholder: 'Маҳсулот номи',
    soldQuantity: 'Сотилган сони',
    products: 'Маҳсулотлар',
    filled: '{{count}} та маҳсулот киритилди',
    totalUnits: 'Жами: {{count}} дона',
    negativeError: 'Сотилган маҳсулотлар сони 0 дан кичик бўлмаслиги керак',
    inStock: 'Омборда: {{count}}',
  },
  users: {
    title: 'Ходимлар',
    subtitle: 'Тизим фойдаланувчилари ва уларнинг филиаллари',
    add: 'Ходим қўшиш',
    name: 'Ходим',
    branches: 'Бириктирилган филиаллар',
    noBranches: 'Филиал бириктирилмаган',
    searchPlaceholder: 'Ходимни қидириш',
    createTitle: 'Янги ходим',
    createSubtitle: 'Тизимга кириш учун логин ва парол яратинг',
    editTitle: 'Маълумотларни янгилаш',
    editSubtitle: 'Логин, email ва паролни ўзгартириш',
    login: 'Логин',
    loginPlaceholder: 'Логинни киритинг',
    email: 'Email',
    emailPlaceholder: 'example@mail.com',
    emailHint: 'Паролни унутганда тасдиқлаш коди шу манзилга юборилади',
    emailInvalid: 'Email нотўғри киритилган',
    noEmail: 'Email киритилмаган',
    emailMissingTitle: 'Email киритинг',
    emailMissingText: 'Email киритилмаган. Паролни унутсангиз, уни тиклаб бўлмайди.',
    password: 'Парол',
    passwordPlaceholder: 'Паролни киритинг',
    newPasswordHint: 'Паролни ўзгартирмасангиз, бўш қолдиринг',
    loginMin: 'Логин камида 4 та белгидан иборат бўлсин',
    passwordMin: 'Парол камида 4 та белгидан иборат бўлсин',
    pages: 'Саҳифаларга рухсат',
    pagesHint: 'Ходим фақат белгиланган саҳифаларни кўра олади',
    pagesRequired: 'Камида битта саҳифани белгиланг',
    count: '{{count}} та ходим',
  },
  branches: {
    title: 'Филиаллар',
    subtitle: 'Савдо нуқталари, масъул ходимлар ва нархлар',
    add: 'Филиал қўшиш',
    name: 'Филиал номи',
    namePlaceholder: 'Масалан: Чилонзор филиали',
    staff: 'Бириктирилган ходимлар',
    staffPlaceholder: 'Ходимларни танланг',
    noStaff: 'Ходим бириктирилмаган',
    prices: 'Нархлар',
    reports: 'Ҳисоботлар',
    searchPlaceholder: 'Филиални қидириш',
    createTitle: 'Янги филиал',
    createSubtitle: 'Филиал номини киритинг ва ходимларни бириктиринг',
    editTitle: 'Филиални таҳрирлаш',
    editSubtitle: 'Филиал номи ва масъул ходимлар',
    pricesTitle: '{{branch}} — нархлар',
    pricesSubtitle: 'Филиалдаги маҳсулотларнинг сотув нархлари',
    editPrices: 'Нархларни ўзгартириш',
    editPricesTitle: '{{branch}} — нархларни ўзгартириш',
    editPricesSubtitle: 'Ҳар бир маҳсулот учун сотув нархини киритинг',
    sellPrice: 'Сотув нархи',
    pricePlaceholder: 'Нарх',
    count: '{{count}} та филиал',
  },
  products: {
    title: 'Склад',
    subtitle: 'Маҳсулотлар, қолдиқлар ва филиаллардаги нархлар',
    create: 'Янги маҳсулот',
    addStock: 'Кирим қилиш',
    name: 'Маҳсулот номи',
    namePlaceholder: 'Маҳсулот номини киритинг',
    searchPlaceholder: 'Маҳсулотни қидириш',
    stock: 'Қолдиқ',
    buyPrice: 'Сотиб олиш нархи',
    buyPricePlaceholder: 'Нархни киритинг',
    quantity: 'Маҳсулот миқдори',
    quantityPlaceholder: 'Миқдорни киритинг',
    branchPrices: 'Филиаллардаги сотув нархлари',
    branchPricesHint: 'Ҳар бир филиал учун сотув нархини киритинг',
    searchBranch: 'Филиални қидириш',
    sellPrice: 'Сотув нархи',
    createTitle: 'Янги маҳсулот',
    createSubtitle: 'Маҳсулот маълумотлари ва филиаллардаги нархлар',
    editTitle: 'Маҳсулотни таҳрирлаш',
    editSubtitle: 'Маҳсулот маълумотлари ва филиаллардаги нархлар',
    addStockTitle: 'Омборга кирим',
    addStockSubtitle: 'Ҳар бир маҳсулот учун келган миқдорни киритинг',
    addQuantity: 'Кирим миқдори',
    currentStock: 'Ҳозирги қолдиқ: {{count}}',
    negativeError: 'Маҳсулот сони 0 дан кичик бўлмаслиги керак',
    statusOk: 'Етарли',
    statusLow: 'Кам қолди',
    statusOut: 'Тугаган',
    count: '{{count}} та маҳсулот',
    filterAll: 'Барчаси',
    filterLow: 'Кам қолганлар',
    general: 'Асосий маълумотлар',
  },
  confirm: {
    deleteTitle: 'Ўчиришни тасдиқланг',
    deleteText: 'Ҳақиқатан ҳам буни ўчирмоқчимисиз? Бу амални ортга қайтариб бўлмайди.',
  },
  notify: {
    created: '{{entity}} муваффақиятли яратилди',
    updated: '{{entity}} муваффақиятли янгиланди',
    deleted: '{{entity}} муваффақиятли ўчирилди',
    added: '{{entity}} муваффақиятли қўшилди',
    createError: '{{entity}} яратишда хатолик',
    updateError: '{{entity}} янгилашда хатолик',
    deleteError: '{{entity}} ўчиришда хатолик',
    addError: '{{entity}} қўшишда хатолик',
    loginSuccess: 'Хуш келибсиз!',
    loginError: 'Логин ёки парол нотўғри',
    logoutSuccess: 'Тизимдан чиқдингиз',
    logoutError: 'Чиқишда хатолик',
    entities: {
      user: 'Ходим',
      branch: 'Филиал',
      product: 'Маҳсулот',
      report: 'Ҳисобот',
      prices: 'Нархлар',
    },
  },
  validation: {
    required: '«{{field}}» майдони тўлдирилиши шарт',
    min: 'Камида {{count}} та белги киритинг',
    nonNegative: 'Қиймат 0 дан кичик бўлмаслиги керак',
    number: 'Рақам киритинг',
  },
  login: {
    title: 'Тизимга кириш',
    subtitle: 'Давом этиш учун ҳисобингизга киринг',
    login: 'Логин',
    loginPlaceholder: 'Логинни киритинг',
    password: 'Парол',
    passwordPlaceholder: 'Паролни киритинг',
    submit: 'Кириш',
    forgotPassword: 'Паролни унутдингизми?',
    asideTitle: 'Савдо автоматлари тармоғини битта панелдан бошқаринг',
    asideText: 'Тушум, омбор қолдиқлари ва филиаллар кўрсаткичлари реал вақтда.',
    feature1: 'Кунлик тушум ва фойда таҳлили',
    feature2: 'Омбор қолдиғи назорати',
    feature3: 'Филиаллар бўйича ҳисоботлар',
  },
  forgotPassword: {
    title: 'Паролни тиклаш',
    subtitle: 'Ҳисобингизга боғланган emailни киритинг — унга 6 хонали тасдиқлаш кодини юборамиз',
    email: 'Email',
    emailPlaceholder: 'example@mail.com',
    submit: 'Код юбориш',
    backToLogin: 'Кириш саҳифасига қайтиш',
    codeTitle: 'Кодни киритинг',
    codeText: '6 хонали тасдиқлаш коди қуйидаги манзилга юборилди:',
    codeHint: 'Код 15 дақиқа амал қилади. Хат келмаган бўлса, “Spam” папкасини текширинг.',
    verify: 'Тасдиқлаш',
    resend: 'Кодни қайта юбориш',
    resendIn: 'Қайта юбориш ({{count}} с)',
    changeEmail: 'Бошқа email киритиш',
  },
  resetPassword: {
    title: 'Янги парол ўрнатиш',
    subtitle: 'Ҳисобингиз учун янги, ишончли парол ўйлаб топинг',
    password: 'Янги парол',
    passwordPlaceholder: 'Янги паролни киритинг',
    confirm: 'Паролни тасдиқланг',
    confirmPlaceholder: 'Паролни қайта киритинг',
    confirmRequired: 'Паролни қайта киритинг',
    mismatch: 'Пароллар мос келмади',
    ruleLength: 'Камида 8 та белги',
    ruleLetter: 'Камида битта ҳарф',
    ruleDigit: 'Камида битта рақам',
    submit: 'Паролни сақлаш',
    successTitle: 'Парол янгиланди',
    successText: 'Энди янги парол билан тизимга киришингиз мумкин.',
  },
  errors: {
    network: 'Сервер билан алоқа йўқ. Интернет алоқасини текширинг',
    unknown: 'Кутилмаган хатолик юз берди. Қайта уриниб кўринг',
    too_many_requests: 'Жуда кўп уриниш. Бир дақиқадан сўнг қайта уриниб кўринг',
    email_required: 'Emailни киритинг',
    email_invalid: 'Email нотўғри киритилган',
    email_email: 'Email нотўғри киритилган',
    email_max: 'Email жуда узун',
    email_unique: 'Бу email бошқа ходимга бириктирилган',
    email_not_found: 'Бу email тизимда рўйхатдан ўтмаган',
    mail_failed: 'Хатни юбориб бўлмади. Бироздан сўнг қайта уриниб кўринг',
    login_required: 'Логинни киритинг',
    login_min: 'Логин камида 4 та белгидан иборат бўлиши керак',
    login_unique: 'Бу логин банд, бошқасини танланг',
    password_required: 'Паролни киритинг',
    password_min: 'Парол камида 4 та белгидан иборат бўлиши керак',
    password_weak: 'Парол камида 8 та белги, ҳарф ва рақамдан иборат бўлиши керак',
    user_not_found: 'Бундай фойдаланувчи топилмади',
    wrong_password: 'Парол нотўғри',
    code_required: '6 хонали кодни тўлиқ киритинг',
    code_invalid: 'Код нотўғри. Emailга келган кодни текшириб, қайта киритинг',
    code_expired: 'Коднинг амал қилиш муддати тугаган. Янги код сўранг',
    code_attempts_exceeded: 'Жуда кўп нотўғри уриниш. Хавфсизлик учун код бекор қилинди — янги код сўранг',
  },
  notFound: {
    title: 'Саҳифа топилмади',
    text: 'Сиз қидирган саҳифа мавжуд эмас ёки кўчирилган.',
    home: 'Бош саҳифага қайтиш',
  },
  errorBoundary: {
    title: 'Кутилмаган хатолик юз берди',
    text: 'Саҳифани қайта юклаб кўринг. Муаммо такрорланса, администраторга мурожаат қилинг.',
    reload: 'Қайта юклаш',
  },
  table: {
    sortAsc: 'Ўсиш бўйича',
    sortDesc: 'Камайиш бўйича',
    cancelSort: 'Саралашни бекор қилиш',
  },
};

export default uzCyrl;
